module.exports = __webpack_public_path__ + "static/media/mailbox.8b33c4fd.svg";